import React from "react";
import PropTypes from "prop-types";
import { useDispatch, connect } from "react-redux";
import { TableButton } from "components/ui";
import { setVmailBatchIds } from "actions/batch";
import { IoRefresh } from "react-icons/lib/io";
import HasRolePermission from "components/shared/has-role-permission";
import { MdVoicemail } from "react-icons/lib/md";
import BulkUpdateVmails from "./bulk-update-voicemails";
import { selectors } from "reducers";
import { Types, startVoicemailAutoDialerWithLockCheck } from "actions/auto-dialer";


const VoicemailTableControls = ({
  refreshData,
  isFetching,
  selectedRows,
  clearSelectedRows,
  user,
  patientsADEnabled
}) => {
  const dispatch = useDispatch();

  const closeAutodialerVoicemailsTab = () => {
    dispatch({ type: Types.VOICEMAIL_AUTODIALER_END });
  }

  return (
    <div className="query-table-controls">
      <TableButton
        onClick={() => {
          refreshData();
        }}
        disabled={isFetching}
      >
        <IoRefresh />
      </TableButton>
      <TableButton
        title={patientsADEnabled ? 'Patients Autodialer Active. Close it to start Voicemails tab ' : `Process (${selectedRows.length} selected Voicemails)`}
        disabled={selectedRows.length === 0 || patientsADEnabled}
        onClick={() => {
          const vmailIds = selectedRows.map(x => x.id);
          dispatch(
            setVmailBatchIds(
              vmailIds,
              selectedRows.map(x => x.vmID)
            )
          );
          dispatch(
            startVoicemailAutoDialerWithLockCheck(
              vmailIds,
              selectedRows.map(x => x.vmID),
              closeAutodialerVoicemailsTab
            )
          );
          clearSelectedRows();
        }}
      >
        <MdVoicemail size={24} />
      </TableButton>
      <HasRolePermission complianceUser={user?.compliance_coach} allowedRoles={["Administrator", "ServiceAdmin", "ContractorAdministrator"]}>
        <BulkUpdateVmails
          selectedRows={selectedRows}
          refreshData={refreshData}
        />
      </HasRolePermission>
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {selectedRows.length > 0 && (
          <span>Selected {selectedRows.length} Voicemails</span>
        )}
      </div>
    </div>
  );
};

export default connect(state => ({
  user: selectors.getUser(state),
  patientsADEnabled: selectors.getIsAutoDialerEnabled(state)
}))(VoicemailTableControls);

VoicemailTableControls.propTypes = {
  refreshData: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  selectedRows: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, patient_name: PropTypes.string })
  ).isRequired,
  clearSelectedRows: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  patientsADEnabled: PropTypes.bool.isRequired
};
